import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=8ca2d442&scoped=true&"
import script from "./Communication.vue?vue&type=script&lang=js&"
export * from "./Communication.vue?vue&type=script&lang=js&"
import style0 from "./Communication.vue?vue&type=style&index=0&id=8ca2d442&scoped=true&lang=css&"
import style1 from "./Communication.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca2d442",
  null
  
)

export default component.exports